import { render, staticRenderFns } from "./consent.vue?vue&type=template&id=5f0f3ab2&scoped=true&lang=pug&"
import script from "./consent.vue?vue&type=script&lang=js&"
export * from "./consent.vue?vue&type=script&lang=js&"
import style0 from "./consent.vue?vue&type=style&index=0&id=5f0f3ab2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0f3ab2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f0f3ab2')) {
      api.createRecord('5f0f3ab2', component.options)
    } else {
      api.reload('5f0f3ab2', component.options)
    }
    module.hot.accept("./consent.vue?vue&type=template&id=5f0f3ab2&scoped=true&lang=pug&", function () {
      api.rerender('5f0f3ab2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/unsubscribe/consent.vue"
export default component.exports